// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "कुल इनाम पॉइंट्स",
          pointsSectionSubtitle: "नए लेवल्स पर पहुंचे और आकर्षक इनाम पाएं",
          dailyRewardsHeader: "दिन का इनाम",
          cardCtaText: "पाने के लिए क्लिक करें",
          allRewardsClaimedTitle: "बधाई हो",
          allRewardsClaimedText: "आपने सभी इनाम पा लिए हैं",
          noRewardsClaimedTitle: "अभी आपके पास कोई इनाम नहीं है",
          noRewardsClaimedText: "कृपया कल दुबारा देखें",
          rewardHistoryFooterText: "इनामों और तोहफों का इतिहास",
          headerText: "पोर्टर रिवॉर्ड प्रोग्राम"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "जीतें " + vehicleModel,
          headerDetails: "जिस पार्टनर के सबसे ज्यादा इनाम पॉइंट्स होंगे वो ये शानदार नया ट्रक जीतेंगे",
          claimedText: "जीता हुआ इनाम",
          toClaimText: "इनाम पाने के लिए क्लिक करें",
          footerText: "आगे बढ़ने पर और लेवल्स खुलेंगे",
          milestone1: "स्टार",
          milestone2: "ब्रोंज हीरो",
          milestone3: "ब्रोंज सुपर स्टार",
          milestone4: "सिल्वर हीरो",
          milestone5: "सिल्वर सुपर स्टार",
          milestone6: "प्लैटिनम हीरो",
          milestone7: "प्लैटिनम सुपर स्टार",
          milestone8: "गोल्ड हीरो",
          milestone9: "गोल्ड सुपर स्टार",
          milestone10: "डायमंड हीरो",
          milestone11: "डायमंड सुपर स्टार",
          milestone12: "पोर्टर हीरो",
          milestone13: "सुप्रो सुपर स्टार",
          locked: "बंद है"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: " बधाई हो !",
          winLabel: " आपने जीता है ",
          winNotice: " हम आपको कॉल कर सूचित करेंगे कि ईनाम कैसे प्राप्त किया जा सकता है ",
          lossNotice: " माफ़ कीजिए। आपने इस बार कोई ईनाम नहीं जीता है। पुरस्कार जीतने के लिए कृपया अगले प्रोग्राम में बेहतर भाग लें। ",
          endTitle: " पोर्टर रिवार्ड कार्यक्रम समाप्त हो गया है । ",
          endText: " अगले प्रोग्राम की सूचना जल्द ही दी जाएगी ",
          scoreTitle: " आपका प्रदर्शन कैसा रहा देखिये ",
          totalScoreSubtext: " कूल एकत्रित पॉइंट्स ",
          customerExperienceScoreSubtext: " 5 स्टार रेटिंग के लिए ",
          orderCompletionScoreSubtext: " आर्डर पूरा करने के लिए ",
          loginActivityScoreSubtext: " लॉग इन के लिए ",
          topGiftsTitle: " कुछ शीर्ष पुरस्कार इस प्रकार हैं ",
          topPartnersTitle: " हमारे कुछ शीर्ष पार्टनर्स ये हैं ",
          partnerName: " पार्टनर का नाम",
          awardTitle: " पुरस्कार जीता "
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "इनाम",
            yesterdayRowTitle: "कल",
            rewardNavTabTitle: "दिन का इनाम",
            awardNavTabTitle: "लेवल पर तोहफें"
          },
          milestoneDetails: getMilestoneDetails("Mahindra"),
          customerServiceRewards: {
            text1: "आपने कमाया हैं",
            text2: "ग्राहक के साथ अच्छा व्यहार करने के लिए"
          },
          loginActivtyRewards: {
            text1: "आपने कमाये है",
            text2: "लॉग-इन गतिविधि"
          },
          orderFulfillmentRewards: {
            text1: "आपने कमाये है",
            text2: "सारे मिले हुए भाड़े करने के लिए"
          },
          mahindraAwards: {
            cardTitle: "जीतें महिंद्रा",
            cardText: "और जाने",
            modalTitle: "जीतें महिंद्रा",
            modalText: "हर महीने आकर्षक इनाम जीतें और भव्य इनाम महिंद्रा सुप्रो जीतें । अधिक जानकारी के लिए अपने पॉइंट्स हर दिन देखें।"
          },
          defaultLCVAward: {
            modalTitle: "इस दिवाली बंपर पुरस्कार और ढेरो इनाम जीतने का मौका पाए !!",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "इस दिवाली बंपर पुरस्कार और ढेरो इनाम जीतने का मौका पाए !!",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "हर हफ्ते मेगा पुरस्कार जीतें",
            modalText: ""
          },
          noAward: {
            cardTitle: "इनाम जीतने के लिए अगले माइलस्टोन पर जल्दी पहुंचें",
            cardText: "आप जिन इनामों को जीत रहे थे उन्हें दूसरे पार्टनर्स ने क्लेम कर लिया है ।",
            modalTitle: "इनाम जीतने के लिए अगले माइलस्टोन पर जल्दी पहुंचें",
            modalText: "आप जिन इनामों को जीत रहे थे उन्हें दूसरे पार्टनर्स ने क्लेम कर लिया है । इनाम जीतने के लिए अगले माइलस्टोन पर जल्दी पहुंचें ।"
          },
          insuranceAward: {
            cardTitle: "आपने वाहन बीमा पर भारी छूट जीती है",
            modalTitle: "बधाई हो !! आपने वाहन बीमा पर भारी छूट जीती है"
          },
          distributionCeremonyAward: {
            cardTitle: "आपको पोर्टर से आकर्षक पुरस्कार जीतने का मौका मिला हैं",
            cardText: "शीर्ष प्रदर्शन करने वाले पार्टनर्स को आकर्षक पुरस्कार जीतने का मौका मिलेगा। शर्तें लागू|",
            modalTitle: "आपको पोर्टर से आकर्षक पुरस्कार जीतने का मौका मिला हैं",
            modalText: "शीर्ष प्रदर्शन करने वाले पार्टनर्स को आकर्षक पुरस्कार जीतने का मौका मिलेगा। शर्तें लागू|"
          },
          finalAward: {
            cardTitle: "आपको पोर्टर की ओर से \"महिंद्रा सुप्रो\" गाड़ी जितने का मौका मिला है",
            cardText: "सर्वत्र भारत में से एक उत्तम प्रदर्शन करने वाले पार्टनर जीतेंगे",
            modalTitle: "आपको पोर्टर की ओर से \"महिंद्रा सुप्रो\" गाड़ी जितने का मौका मिला है",
            modalText: "सर्वत्र भारत में से एक उत्तम प्रदर्शन करने वाले पार्टनर जीतेंगे. समारोह के अंत में विजेता घोषित किया जाएगा. T&C applied"
          },
          couponAward: {
            couponText: "कूपन",
            redeemTitle: "डिस्काउंट लेने का तरीका",
            detailsText: "विवरण",
            tncText: "नियम एवं शर्तें",
            codeAckTitle: "कूपन कोड कॉपी किया गया"
          },
          status: {
            loading: "लोड हो रहा है",
            internetNotConnected: "इंटरनेट उपलब्ध नहीं है",
            tapToRetry: "पुनः प्रयास करें",
            ise: "कुछ समस्या हुई है",
            loadingFailed: "लोडिंग फेल हो गया"
          },
          category: {
            customerService: "ग्राहक सेवा",
            loginHours: "लॉग-इन गतिविधि",
            orderFulfillment: "किये गए भाड़े"
          },
          customerServiceDetails: {
            details1: "जब आपके भाड़ों के लिए ग्राहक आपको 5 स्टार रेटिंग देतें है तब आपके  ग्राहक सेवा पॉइंट बढ़ेंगे",
            details2: "इसलिए 5 स्टार वाले भाड़ों की संख्या बढ़ाएं",
            sectionHeader: "5 स्टार रेटिंग कैसे प्राप्त करें ?",
            tip1: "हमेशा ग्राहक के साथ विनम्र रहें और उन्हें सम्मान दें",
            tip2: "कभी भी ग्राहकों से बहस न करें। विवादों की स्थिति में कॉल सेंटर से सहायता लें।",
            tip3: "ग्राहक के सामान को ध्यान पूर्वक संभाले"
          },
          loginHourDetails: {
            details1: "ज्यादा ऑनलाइन रहें, ज्यादा लॉग-इन गतिविधि पॉइंट्स पाएं",
            tips: "सुझाव",
            tip: "अपने खाली समय में ऑनलाइन रहें और ज्यादा कमाएं"
          },
          orderFulfillmentDetails: {
            details1: "किये गए भाड़ों पर पॉइंट्स कैसे कमाएं ?",
            details2: "जिन भाड़ों को आप पूरा करना चाहते है सिर्फ उन्ही को स्वीकार करें।",
            tip1: "भाड़ा मिलने क बाद उसे कभी कैंसिल ना करें",
            tip2: "ग्राहक को कभी भाड़ा कैंसिल करने के लिए ना बोलें",
            slabTableText: "किये गए भाड़ों के पॉइंट्स",
            slabTableCol1: "किये गए भाड़े",
            slabTableCol2: "पॉइंट्स"
          },
          miscellaneous: {
            points: "पॉइंट्स"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "" + date + " को समाप्त हो जाएगा";
            }),
          getExpiringDateTitle: (function (date) {
              return "वैद्यता समाप्ति की तारीख " + date;
            }),
          getExpiryHoursTitle: (function (hours) {
              return "" + hours + " में समाप्त हो जाएगा";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "आप एक " + currentMilestone + " हैं";
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + nextMilestone + " बनने के लिए " + points + " पॉइंट्स की जरुरत है";
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " पांच स्टार भाड़े ";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return " आपने " + completedOrders + " भाड़े किये हैं ";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return "पुरस्कारित लॉग इन घंटे " + loginHours;
            }),
          getLoginRewardsDetailsText: (function (points) {
              return "आपके पास " + points + " लॉग-इन गतिविधि पॉइंट्स हैं";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "आपके पास " + points + " ग्राहक सेवा पॉइंट्स हैं";
            }),
          getNextMilestoneSubText: (function (points) {
              return "" + points + " पॉइंट्स दूर हैं";
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return " आपको हर 5 स्टार ऑर्डर के लिए " + points + " अंक मिलते हैं ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return "" + startTime + " से " + endTime + " के बीच ऑनलाइन रहने से आपके लॉग-इन गतिविधि पॉइंट्स बढ़ेंगे";
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "" + startTime + " से " + endTime + " के बीच और अधिक ऑनलाइन रहें";
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " हर लोग-इन किये घंटे के लिए " + points + " पॉइंट्स पाएं. ज्यादा लॉग-इन का मतलब ज्यादा पॉइंट्स  ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return "किये गए भाड़ों के लिए आपके पास " + points + " पॉइंट्स है ";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return "आप प्रतिदिन केवल " + points + " पॉइंट्स कमा सकते हैं ";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " " + points + " पॉइंट्स और चाहिए ";
            }),
          getLastSlabText: (function (orders) {
              return "" + orders + " या ज्यादा ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " आपने " + fuelQuantity + " लीटर डीजल जीता है । ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " आपके वॉलेट में " + fuelMoney + " रूपये डाल दिए गए है ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " बधाई हो !! आपने " + fuelQuantity + " लीटर डीजल जीता है । ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " आपके वॉलेट में " + fuelMoney + " रूपये डाल दिए गए हैं ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " अब आपको आर्डर में " + acceptAdvantage + " सेकण्ड्स की देरी नहीं मिलेगी ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " अब आपको " + endDate + " तक ऑर्डर्स में " + acceptAdvantage + " सेकण्ड्स की देरी नहीं मिलेगी ";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " बधाई हो !! अब आपको आर्डर में " + acceptAdvantage + " सेकण्ड्स की देरी नहीं मिलेगी ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " आपने पोर्टर प्रीमियम पार्टनर पुरस्कार जीता है। अब आपको ऑर्डर में नीचे दी गई तारीखों के दौरान " + acceptAdvantage + " सेकंड की देरी का सामना नहीं करना पड़ेगा।\n        आरंभ तिथि - " + startDate + "\n        समाप्ति तिथि - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " आपने ₹ " + amount + " जीते हैं ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " जीते हुए ₹ " + amount + " आपके वॉलेट में डाल दिए गए हैं ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " बधाई हो !! आपने ₹ " + amount + " जीते हैं ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " जीते हुए ₹ " + amount + " आपके वॉलेट में डाल दिए गए हैं ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " आप अपना जीता हुआ वाहन बीमा पोर्टर से ₹ " + price + " में ले सकते हैं। वैधता " + endDate + " तक ।";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " आप अपना जीता हुआ वाहन बीमा पोर्टर से ₹ " + price + " में ले सकते हैं। वैधता " + endDate + " तक ।";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " आपने पोर्टर से वाहन बीमा पर ₹ " + discount + " रुपये की छूट का ईनाम जीता है। वैधता " + endDate + " तक ।";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " आपने पोर्टर से वाहन बीमा पर ₹ " + discount + " रुपये की छूट का ईनाम जीता है। वैधता " + endDate + " तक ।";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " आप " + multiplier + " इनाम पॉइंट्स जीतेंगे ";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " आप " + startDate + " से हर कैटेगोरी में " + multiplier + " इनाम पॉइंट्स जीतेंगे। वैधता " + endDate + " तक ";
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " बधाई हो !! आप " + multiplier + " इनाम पॉइंट्स जीतेंगे ";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " आप " + startDate + " से हर कैटेगोरी में " + multiplier + " इनाम पॉइंट्स जीतेंगे। वैधता " + endDate + " तक ";
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " " + recipient_cnt + " पार्टनर्स को सम्मानित किया गया ";
            })
        };
}

var Hindi = {
  getContent: getContent
};

export {
  Hindi ,
  
}
/* No side effect */
